import { c as _c } from "react/compiler-runtime";
import { IcoBuilding16, IcoChecklist16, IcoDropdown16, IcoHashtag16, IcoLongText16, IcoMultipleChoice16, IcoPlusSmall16, IcoShortText16, IcoSquareCheck16, IcoTextBlock16 } from '@onefootprint/icons';
import { Checkbox, Dropdown, Radio, Select, TextArea, TextInput } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
type AddContentDropdownProps = {
  onSelect: (contentType: string) => void;
  onOpenChange: (open: boolean) => void;
};
const AddContentDropdown = t0 => {
  const $ = _c(147);
  const {
    onSelect,
    onOpenChange
  } = t0;
  const {
    t
  } = useTranslation("playbook-custom-questions");
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] !== onOpenChange) {
    t1 = next => {
      setOpen(next);
      onOpenChange(next);
    };
    $[0] = onOpenChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOpenChange = t1;
  let t2;
  if ($[2] !== handleOpenChange || $[3] !== onSelect) {
    t2 = contentType => () => {
      onSelect(contentType);
      handleOpenChange(false);
    };
    $[2] = handleOpenChange;
    $[3] = onSelect;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const select = t2;
  const t3 = !open;
  let t4;
  if ($[5] !== open || $[6] !== t3) {
    t4 = cx("flex w-full items-center justify-center gap-1.5 rounded-md border border-dashed py-2.5 text-label-3 transition-colors", {
      "border-accent bg-accent/6 text-accent": open,
      "border-primary text-tertiary hover:border-primary-hover": t3
    });
    $[5] = open;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IcoPlusSmall16 />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t(_temp);
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <Dropdown.Trigger asChild={true} width="100%"><button type="button" className={t4}>{t5}{t6}</button></Dropdown.Trigger>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t(_temp2);
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <Dropdown.GroupTitle>{t8}</Dropdown.GroupTitle>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== select) {
    t10 = select("short_text");
    $[18] = select;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t(_temp3);
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11) {
    t12 = <Dropdown.SubTrigger iconLeft={IcoShortText16} onClick={t10}>{t11}</Dropdown.SubTrigger>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Dropdown.Portal><Dropdown.SubContent sideOffset={12} className="max-md:hidden"><div className="p-3 w-[260px] bg-primary rounded-md border-2 border-accent pointer-events-none"><TextInput label="What's your name?" value="John Smith" size="compact" /></div></Dropdown.SubContent></Dropdown.Portal>;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12) {
    t14 = <Dropdown.Sub>{t12}{t13}</Dropdown.Sub>;
    $[26] = t12;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== select) {
    t15 = select("long_text");
    $[28] = select;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t) {
    t16 = t(_temp4);
    $[30] = t;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t15 || $[33] !== t16) {
    t17 = <Dropdown.SubTrigger iconLeft={IcoLongText16} onClick={t15}>{t16}</Dropdown.SubTrigger>;
    $[32] = t15;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Dropdown.Portal><Dropdown.SubContent sideOffset={12} className="max-md:hidden"><div className="p-3 w-[260px] bg-primary rounded-md border-2 border-accent pointer-events-none"><TextArea label="Anything you'd like to add?" placeholder="Type here..." rows={5} /></div></Dropdown.SubContent></Dropdown.Portal>;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t17) {
    t19 = <Dropdown.Sub>{t17}{t18}</Dropdown.Sub>;
    $[36] = t17;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== select) {
    t20 = select("text_block");
    $[38] = select;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t) {
    t21 = t(_temp5);
    $[40] = t;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t20 || $[43] !== t21) {
    t22 = <Dropdown.SubTrigger iconLeft={IcoTextBlock16} onClick={t20}>{t21}</Dropdown.SubTrigger>;
    $[42] = t20;
    $[43] = t21;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Dropdown.Portal><Dropdown.SubContent sideOffset={12} className="max-md:hidden"><div className="p-3 w-[260px] bg-primary rounded-md border-2 border-accent pointer-events-none"><div className="text-body-2 text-primary">By continuing, you agree to provide accurate information and consent to the processing of your data for verification and compliance purposes. You understand that your data may be securely shared with trusted third parties as required to complete this process.</div></div></Dropdown.SubContent></Dropdown.Portal>;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== t22) {
    t24 = <Dropdown.Sub>{t22}{t23}</Dropdown.Sub>;
    $[46] = t22;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== t14 || $[49] !== t19 || $[50] !== t24) {
    t25 = <Dropdown.Group>{t14}{t19}{t24}</Dropdown.Group>;
    $[48] = t14;
    $[49] = t19;
    $[50] = t24;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <Dropdown.Divider />;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t) {
    t27 = t(_temp6);
    $[53] = t;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== t27) {
    t28 = <Dropdown.GroupTitle>{t27}</Dropdown.GroupTitle>;
    $[55] = t27;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] !== select) {
    t29 = select("multiple_choice");
    $[57] = select;
    $[58] = t29;
  } else {
    t29 = $[58];
  }
  let t30;
  if ($[59] !== t) {
    t30 = t(_temp7);
    $[59] = t;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  let t31;
  if ($[61] !== t29 || $[62] !== t30) {
    t31 = <Dropdown.SubTrigger iconLeft={IcoMultipleChoice16} onClick={t29}>{t30}</Dropdown.SubTrigger>;
    $[61] = t29;
    $[62] = t30;
    $[63] = t31;
  } else {
    t31 = $[63];
  }
  let t32;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <Dropdown.Portal><Dropdown.SubContent sideOffset={12} className="max-md:hidden"><div className="p-3 w-[260px] bg-primary rounded-md border-2 border-accent pointer-events-none"><div className="flex flex-col gap-2"><div className="text-label-2 text-primary mb-1">Do you own a car?</div><Radio label="Yes" value="yes" name="car" /><Radio label="No" value="no" name="car" /></div></div></Dropdown.SubContent></Dropdown.Portal>;
    $[64] = t32;
  } else {
    t32 = $[64];
  }
  let t33;
  if ($[65] !== t31) {
    t33 = <Dropdown.Sub>{t31}{t32}</Dropdown.Sub>;
    $[65] = t31;
    $[66] = t33;
  } else {
    t33 = $[66];
  }
  let t34;
  if ($[67] !== select) {
    t34 = select("multi-select");
    $[67] = select;
    $[68] = t34;
  } else {
    t34 = $[68];
  }
  let t35;
  if ($[69] !== t) {
    t35 = t(_temp8);
    $[69] = t;
    $[70] = t35;
  } else {
    t35 = $[70];
  }
  let t36;
  if ($[71] !== t34 || $[72] !== t35) {
    t36 = <Dropdown.SubTrigger iconLeft={IcoChecklist16} onClick={t34}>{t35}</Dropdown.SubTrigger>;
    $[71] = t34;
    $[72] = t35;
    $[73] = t36;
  } else {
    t36 = $[73];
  }
  let t37;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <Dropdown.Portal><Dropdown.SubContent sideOffset={12} className="max-md:hidden"><div className="p-3 w-[260px] bg-primary rounded-md border-2 border-accent pointer-events-none"><div className="flex flex-col gap-2"><div className="text-label-2 text-primary mb-1">What best describes you?</div><Checkbox label="New customer" /><Checkbox label="Returning customer" /><Checkbox label="Evaluating for work" /><Checkbox label="Just browsing" /></div></div></Dropdown.SubContent></Dropdown.Portal>;
    $[74] = t37;
  } else {
    t37 = $[74];
  }
  let t38;
  if ($[75] !== t36) {
    t38 = <Dropdown.Sub>{t36}{t37}</Dropdown.Sub>;
    $[75] = t36;
    $[76] = t38;
  } else {
    t38 = $[76];
  }
  let t39;
  if ($[77] !== select) {
    t39 = select("dropdown");
    $[77] = select;
    $[78] = t39;
  } else {
    t39 = $[78];
  }
  let t40;
  if ($[79] !== t) {
    t40 = t(_temp9);
    $[79] = t;
    $[80] = t40;
  } else {
    t40 = $[80];
  }
  let t41;
  if ($[81] !== t39 || $[82] !== t40) {
    t41 = <Dropdown.SubTrigger iconLeft={IcoDropdown16} onClick={t39}>{t40}</Dropdown.SubTrigger>;
    $[81] = t39;
    $[82] = t40;
    $[83] = t41;
  } else {
    t41 = $[83];
  }
  let t42;
  if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <Dropdown.Portal><Dropdown.SubContent sideOffset={12} className="max-md:hidden"><div className="p-3 w-[260px] bg-primary rounded-md border-2 border-accent pointer-events-none"><Select label="What car do you drive?" value="tesla-model-3" onChange={_temp10} options={[{
            label: "Tesla Model 3",
            value: "tesla-model-3"
          }, {
            label: "Toyota Camry",
            value: "toyota-camry"
          }, {
            label: "Honda Civic",
            value: "honda-civic"
          }]} size="compact" /></div></Dropdown.SubContent></Dropdown.Portal>;
    $[84] = t42;
  } else {
    t42 = $[84];
  }
  let t43;
  if ($[85] !== t41) {
    t43 = <Dropdown.Sub>{t41}{t42}</Dropdown.Sub>;
    $[85] = t41;
    $[86] = t43;
  } else {
    t43 = $[86];
  }
  let t44;
  if ($[87] !== select) {
    t44 = select("checkbox");
    $[87] = select;
    $[88] = t44;
  } else {
    t44 = $[88];
  }
  let t45;
  if ($[89] !== t) {
    t45 = t(_temp11);
    $[89] = t;
    $[90] = t45;
  } else {
    t45 = $[90];
  }
  let t46;
  if ($[91] !== t44 || $[92] !== t45) {
    t46 = <Dropdown.SubTrigger iconLeft={IcoSquareCheck16} onClick={t44}>{t45}</Dropdown.SubTrigger>;
    $[91] = t44;
    $[92] = t45;
    $[93] = t46;
  } else {
    t46 = $[93];
  }
  let t47;
  if ($[94] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <Dropdown.Portal><Dropdown.SubContent sideOffset={12} className="max-md:hidden"><div className="p-3 w-[260px] bg-primary rounded-md border-2 border-accent pointer-events-none"><Checkbox label="I agree to the terms and conditions" /></div></Dropdown.SubContent></Dropdown.Portal>;
    $[94] = t47;
  } else {
    t47 = $[94];
  }
  let t48;
  if ($[95] !== t46) {
    t48 = <Dropdown.Sub>{t46}{t47}</Dropdown.Sub>;
    $[95] = t46;
    $[96] = t48;
  } else {
    t48 = $[96];
  }
  let t49;
  if ($[97] !== t33 || $[98] !== t38 || $[99] !== t43 || $[100] !== t48) {
    t49 = <Dropdown.Group>{t33}{t38}{t43}{t48}</Dropdown.Group>;
    $[97] = t33;
    $[98] = t38;
    $[99] = t43;
    $[100] = t48;
    $[101] = t49;
  } else {
    t49 = $[101];
  }
  let t50;
  if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <Dropdown.Divider />;
    $[102] = t50;
  } else {
    t50 = $[102];
  }
  let t51;
  if ($[103] !== t) {
    t51 = t(_temp12);
    $[103] = t;
    $[104] = t51;
  } else {
    t51 = $[104];
  }
  let t52;
  if ($[105] !== t51) {
    t52 = <Dropdown.GroupTitle>{t51}</Dropdown.GroupTitle>;
    $[105] = t51;
    $[106] = t52;
  } else {
    t52 = $[106];
  }
  let t53;
  if ($[107] !== select) {
    t53 = select("number");
    $[107] = select;
    $[108] = t53;
  } else {
    t53 = $[108];
  }
  let t54;
  if ($[109] !== t) {
    t54 = t(_temp13);
    $[109] = t;
    $[110] = t54;
  } else {
    t54 = $[110];
  }
  let t55;
  if ($[111] !== t53 || $[112] !== t54) {
    t55 = <Dropdown.SubTrigger iconLeft={IcoHashtag16} onClick={t53}>{t54}</Dropdown.SubTrigger>;
    $[111] = t53;
    $[112] = t54;
    $[113] = t55;
  } else {
    t55 = $[113];
  }
  let t56;
  if ($[114] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = <Dropdown.Portal><Dropdown.SubContent sideOffset={12} className="max-md:hidden"><div className="p-3 w-[260px] bg-primary rounded-md border-2 border-accent pointer-events-none"><TextInput label="How many hours?" value="8" size="compact" type="number" /></div></Dropdown.SubContent></Dropdown.Portal>;
    $[114] = t56;
  } else {
    t56 = $[114];
  }
  let t57;
  if ($[115] !== t55) {
    t57 = <Dropdown.Sub>{t55}{t56}</Dropdown.Sub>;
    $[115] = t55;
    $[116] = t57;
  } else {
    t57 = $[116];
  }
  let t58;
  if ($[117] !== select) {
    t58 = select("address");
    $[117] = select;
    $[118] = t58;
  } else {
    t58 = $[118];
  }
  let t59;
  if ($[119] !== t) {
    t59 = t(_temp14);
    $[119] = t;
    $[120] = t59;
  } else {
    t59 = $[120];
  }
  let t60;
  if ($[121] !== t58 || $[122] !== t59) {
    t60 = <Dropdown.SubTrigger iconLeft={IcoBuilding16} onClick={t58}>{t59}</Dropdown.SubTrigger>;
    $[121] = t58;
    $[122] = t59;
    $[123] = t60;
  } else {
    t60 = $[123];
  }
  let t61;
  if ($[124] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = <div className="text-label-2 text-primary">Address</div>;
    $[124] = t61;
  } else {
    t61 = $[124];
  }
  let t62;
  let t63;
  let t64;
  if ($[125] === Symbol.for("react.memo_cache_sentinel")) {
    t62 = <Select placeholder="Select a country" value="" options={[]} onChange={_temp15} size="compact" />;
    t63 = <TextInput placeholder="Street address" size="compact" />;
    t64 = <TextInput placeholder="Apartment, suite, etc." size="compact" />;
    $[125] = t62;
    $[126] = t63;
    $[127] = t64;
  } else {
    t62 = $[125];
    t63 = $[126];
    t64 = $[127];
  }
  let t65;
  if ($[128] === Symbol.for("react.memo_cache_sentinel")) {
    t65 = <div className="flex gap-4"><TextInput placeholder="City" size="compact" className="flex-1" /><TextInput placeholder="ZIP code" size="compact" className="flex-1" /></div>;
    $[128] = t65;
  } else {
    t65 = $[128];
  }
  let t66;
  if ($[129] === Symbol.for("react.memo_cache_sentinel")) {
    t66 = <Dropdown.Portal><Dropdown.SubContent sideOffset={12} className="max-md:hidden"><div className="p-3 w-[260px] bg-primary rounded-md border-2 border-accent pointer-events-none flex flex-col gap-4">{t61}{t62}{t63}{t64}{t65}<Select placeholder="Select state" value="" options={[]} onChange={_temp16} size="compact" /></div></Dropdown.SubContent></Dropdown.Portal>;
    $[129] = t66;
  } else {
    t66 = $[129];
  }
  let t67;
  if ($[130] !== t60) {
    t67 = <Dropdown.Sub>{t60}{t66}</Dropdown.Sub>;
    $[130] = t60;
    $[131] = t67;
  } else {
    t67 = $[131];
  }
  let t68;
  if ($[132] !== t57 || $[133] !== t67) {
    t68 = <Dropdown.Group>{t57}{t67}</Dropdown.Group>;
    $[132] = t57;
    $[133] = t67;
    $[134] = t68;
  } else {
    t68 = $[134];
  }
  let t69;
  if ($[135] !== t25 || $[136] !== t28 || $[137] !== t49 || $[138] !== t52 || $[139] !== t68 || $[140] !== t9) {
    t69 = <Dropdown.Content align="center" side="bottom" className="w-[260px]">{t9}{t25}{t26}{t28}{t49}{t50}{t52}{t68}</Dropdown.Content>;
    $[135] = t25;
    $[136] = t28;
    $[137] = t49;
    $[138] = t52;
    $[139] = t68;
    $[140] = t9;
    $[141] = t69;
  } else {
    t69 = $[141];
  }
  let t70;
  if ($[142] !== handleOpenChange || $[143] !== open || $[144] !== t69 || $[145] !== t7) {
    t70 = <Dropdown.Root open={open} onOpenChange={handleOpenChange}>{t7}{t69}</Dropdown.Root>;
    $[142] = handleOpenChange;
    $[143] = open;
    $[144] = t69;
    $[145] = t7;
    $[146] = t70;
  } else {
    t70 = $[146];
  }
  return t70;
};
export default AddContentDropdown;
function _temp($) {
  return $.addContent.button;
}
function _temp2($_0) {
  return $_0.addContent.text;
}
function _temp3($_1) {
  return $_1.addContent.shortText;
}
function _temp4($_2) {
  return $_2.addContent.longText;
}
function _temp5($_3) {
  return $_3.addContent.textBlock;
}
function _temp6($_4) {
  return $_4.addContent.choice;
}
function _temp7($_5) {
  return $_5.addContent.multipleChoice;
}
function _temp8($_6) {
  return $_6.addContent.multiSelect;
}
function _temp9($_7) {
  return $_7.addContent.dropdown;
}
function _temp10() {}
function _temp11($_8) {
  return $_8.addContent.checkbox;
}
function _temp12($_9) {
  return $_9.addContent.other;
}
function _temp13($_10) {
  return $_10.addContent.number;
}
function _temp14($_11) {
  return $_11.addContent.address;
}
function _temp15() {}
function _temp16() {}